//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import GameMorePanelView from "./game_morepanel_view";
import ModuleManager from "../../../../framework/core/module_manager";
import AudioManager from "../../../../manager/audio_manager";
import Record from "../../../hall/module/record/record"
import EventManager from "../../../../manager/event_manager";
import GameRule from "../game_rule/game_rule";
import AppData from '../../../public/const/app_data';
import Customer from "../../../hall/module/customer/customer";
import SlotRuleModule from "../../../slot/module/rule/slot_rule_module";
import Bag from "../../../hall/module/bag/bag";
import GameServer from "../../../hall/server/gameserver/game_server";
import SceneManager from "../../../../manager/scene_manager";
@ccclass
@moduleInit("GameMorePanel")
export default class GameMorePanel extends ModuleBase<GameMorePanelView, null> {
    isOpenSound = false
    isOpenMusic = false
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/table/game_morepanel";
        this.viewType = GameMorePanelView;
        this.needAnim = false
    }

    protected m_show_module_callback: Function = null
    protected m_onFinishShowModuleCallback: Function = null

    onShow(intentData) {
        this.view.tweenTo("Start", false)
        this.view.updateBtnStatus(this.view.musicBtnSpr, AudioManager.instance.isMusicOpen())
        this.view.updateBtnStatus(this.view.soundBtnSpr, AudioManager.instance.isSoundOpen())
        this.view.labelServer.node.active = false
        if(intentData){
            this.m_show_module_callback = intentData.showModuleCallback
            this.m_onFinishShowModuleCallback = intentData.onFinishShowModuleCallback
        }else{
            this.m_show_module_callback = null
            this.m_onFinishShowModuleCallback = null
        }
        
        if (AppData.serverCurGame) {
            this.view.labelServer.node.active = true
            this.view.labelServer.string = "v" + AppData.serverCurGame
        }
    }

    protected onButtonClickName(name: string) {
        let self = this
        switch (name) {
            case "MoreMaskBtn":
                this.view.tweenTo("Start", true)
                this.hideSelf()
                break
            case "CloseBtn":
                self.hide()
                if (GameServer.instance.netClient.isActiveClose()) {
                    SceneManager.gotoHallOrClubHall("TabelExit")
                } else {
                    EventManager.instance.dispatch("event_exit_game")
                }
                break
            case "RecordBtn":
                self.hide()
                if(AppData.gameSimpleName != "SLOT"){
                    ModuleManager.instance.showModule(Record, null, (module)=>{
                        this.m_onFinishShowModuleCallback && this.m_onFinishShowModuleCallback(module)
                    })
                    this.m_show_module_callback && this.m_show_module_callback(Record)
                } 
                break;
            case "HelpBtn":
                self.hide()
                if(AppData.gameSimpleName != "SLOT"){
                    ModuleManager.instance.showModule(GameRule, null, (module)=>{
                        this.m_onFinishShowModuleCallback && this.m_onFinishShowModuleCallback(module)
                    })
                    this.m_show_module_callback && this.m_show_module_callback(GameRule)
                }else{
                    ModuleManager.instance.showModule(SlotRuleModule)
                }
                
                break;
            case "BagBtn":
                self.hide()
                ModuleManager.instance.showModule<Bag>(Bag, { tag: 'tag_daoju' })
                break;
            case "MusicBtn":
                this.onMusicClick()
                break;
            case "SoundBtn":
                this.onSoundClick()
                break;
            case "CustomServerBtn":
                self.hide()
                ModuleManager.instance.showModule<Customer>(Customer, {
                    "customerType": 1,
                })
                break;
            default:
                break
        }
    }

    hideSelf() {
        let self = this
        self.scheduleOnce(function () {
            self.hide()
        }, 0.2)
    }
    
    onHide() {
        super.onHide()
    }

    onDisable() {
        this.unscheduleAllCallbacks()
    }

    onDestroy() {
        this.unscheduleAllCallbacks()
    }

    onMusicClick(){
        if (AudioManager.instance.isMusicOpen()) {
            AudioManager.instance.setMusicOpen(false)
            AudioManager.instance.pauseMusic()
        } else {
            AudioManager.instance.setMusicOpen(true)
            AudioManager.instance.resumeMusic()
        }
        this.view.updateBtnStatus(this.view.musicBtnSpr, AudioManager.instance.isMusicOpen())
    }

    onSoundClick(){
        if (AudioManager.instance.isSoundOpen()) {
            AudioManager.instance.setSoundOpen(false)
        } else {
            AudioManager.instance.setSoundOpen(true)
        }
        this.view.updateBtnStatus(this.view.soundBtnSpr, AudioManager.instance.isSoundOpen())
    }
}